// @flow
export default /[a-zA-Z][-+.a-zA-Z0-9]*:[-\w.~:/?#[\]@!$&'()*+,;=%]+/;
